import get from 'lodash/get';
import React, { useState, useCallback, useMemo } from 'react';

import SingleSelect from '../../../../common/SingleSelect';

import styles from './styles.styl';

export const usePCPField = ({ details, formatMessage, pcpProviderAnswer }) => {
  const [pcpAnswer, setPcpAnswer] = useState(null);
  const hasPrimaryCareProvider = get(details, 'hasPrimaryCareProvider', true);
  const shouldContinue = Boolean(
    hasPrimaryCareProvider ||
      (!hasPrimaryCareProvider && pcpAnswer) ||
      pcpProviderAnswer !== 'N',
  );
  const providerQuestion = formatMessage({
    id: 'profile.fields.helpFindProvider',
  });
  const answers = {
    S: formatMessage({ id: 'common.yes' }),
    N: formatMessage({ id: 'common.no' }),
  };
  const list = Object.entries(answers).map(([k, v]) => ({
    label: v,
    value: k,
  }));

  const handleOptionChange = useCallback(value => {
    setPcpAnswer(value);
  }, []);

  const PCPField = ({ children }) => children;

  const renderPcpField = useMemo(
    () => (
      <PCPField>
        <div className={styles.questions}>{providerQuestion}</div>
        <SingleSelect
          name="pcpQ"
          list={list}
          radioInputClass={styles.list}
          onChange={handleOptionChange}
          selectedValue={pcpAnswer}
        />
      </PCPField>
    ),
    [],
  );

  return hasPrimaryCareProvider || pcpProviderAnswer !== 'N'
    ? { shouldContinue }
    : {
        pcpAnswer,
        shouldContinue,
        renderPcpField,
      };
};



// WEBPACK FOOTER //
// ./src/components/AppointmentForm/AppointmentHealthInformation/HealthInformationForm/hooks/index.jsx